import { render, staticRenderFns } from "./TitleIcon.vue?vue&type=template&id=bbd62a7c"
import script from "./TitleIcon.vue?vue&type=script&lang=js"
export * from "./TitleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports